import React from 'react'
import { graphql, useFragment } from 'react-relay'
import { DiscussionEmbed } from 'disqus-react'
import { getCurrentLocationFull } from 'services/router'
import { useRouter } from 'next/router'
import { BlogPostLanding_BlogPost$key } from '__generated__/BlogPostLanding_BlogPost.graphql'
import { Card } from '@mui/material'
import Page from 'components/Page'
import PageHeader from 'components/PageHeader'
import PageBody from 'components/PageBody'
import PageContent from 'components/PageContent'
import PageSidebar from 'components/PageSidebar'
import Suspense from 'components/Suspense'
import { PageLoadingIndicator } from 'components/Layouts/V3'
import BlogPostContent from '../BlogPostContent/BlogPostContent'
import ProfileHireBox from '../BlogPostSignedIn/components/ProfileHireBox'

export interface IBlogPostLandingProps {
  blogPostFragmentRef: BlogPostLanding_BlogPost$key
}

function BlogPostLanding(props: IBlogPostLandingProps) {
  const { blogPostFragmentRef } = props
  const router = useRouter()

  const blogPost = useFragment(
    graphql`
      fragment BlogPostLanding_BlogPost on BlogPost {
        id
        title
        ...BlogPostContent_BlogPost
        ...ProfileHireBox_BlogPostFragment
      }
    `,
    blogPostFragmentRef,
  )

  if (!blogPost) {
    return null
  }

  return (
    <div>
      <Page>
        <PageHeader compact />

        <PageBody>
          <PageContent maxWidth="lg">
            <Card raised>
              <Suspense fallback={<PageLoadingIndicator />}>
                <BlogPostContent blogPostFragmentRef={blogPost} />
              </Suspense>
            </Card>

            <DiscussionEmbed
              config={{ url: getCurrentLocationFull(router), identifier: blogPost?.id.toString(), title: blogPost?.title }}
              shortname={process.env.NEXT_PUBLIC_DISQUS_SHORTNAME || ''}
            />
          </PageContent>

          <PageSidebar sticky>
            <ProfileHireBox blogPostFragment={blogPost} />
          </PageSidebar>
        </PageBody>
      </Page>
    </div>
  )
}

export default React.memo(BlogPostLanding)
